export const extractNoderefsFromFormTableFieldDataJSON = (formTableFieldDataJSON: any[]) => {
    return typeof formTableFieldDataJSON !== 'undefined' && Array.isArray(formTableFieldDataJSON) ?
        formTableFieldDataJSON.reduce((acc, formTableFieldDataRowJSON) => {
            const rowNodeRefs: string[] = Object.values(formTableFieldDataRowJSON).reduce((acc: any[], tableCellValue: any | any[]) => {
                const cellNodeRefs: string[] = typeof tableCellValue === 'string' ? (tableCellValue.startsWith("workspace://") ? [tableCellValue] : []) :
                    Array.isArray(tableCellValue) ?
                        (tableCellValue.filter((it) => { return typeof it === 'string' && it.startsWith("workspace://") })) : [];
                return [...acc, ...cellNodeRefs];
            }, []);
            return [...acc, ...rowNodeRefs];
        }, []) :
        [];
};

export const extractTableFields = (allFormFields: { [key: string]: any; }) => Object.values(allFormFields)
    .filter((field) => field?.control?.template === `/org/alfresco/components/form/controls/tableMM.ftl`);

export const extractNoderefsFromTableFields = (formTableFields: any[]) => {
    const usedNoderefs = formTableFields.reduce((acc, formTableField) => {
        let formTableFieldDataJSON;
        try {
            formTableFieldDataJSON = JSON.parse(formTableField.value);
        } catch (err) {
            console.error(err);
        }
        const rows = formTableFieldDataJSON ? extractNoderefsFromFormTableFieldDataJSON(formTableFieldDataJSON) : [];
        return [...acc, ...rows]
    }, []);
    return usedNoderefs;
}

export const substituteNodeRefsByLabel = (data: { [key: string]: string }[], headers: any, usedObjects: { [key: string]: any }) => {
    return data.map((row) => {
        return Object.fromEntries(headers.map((columnHeader: any) => {
            return [columnHeader?.key ?? columnHeader?.id ?? "" /* key for Entry */, ((it) => { return it; })(getTableCellValue(columnHeader.type, row[columnHeader.key ?? columnHeader.id ?? ""], usedObjects))];
        }));

    });
};

export const getTableCellValue = (type: string, value: any, usedObjects: any) => {
    if (!value) { 
        return `(${window.Alfresco.messages.global['label.unfilled'] || 'Nevyplněno' })` 
    }

    switch (type) {
        case 'USERASSOC':
        case 'GROUPASSOC':
        case 'USERGROUPASSOC': {
            if (value && Array.isArray(value)) {
                return value.map((it) => { return usedObjects?.[it]?.name || usedObjects?.[it]?.title || usedObjects?.[it]?.displayName || "..." }).join(", ");
            };
            return value ? usedObjects?.[value]?.name || usedObjects?.[value]?.title || usedObjects?.[value]?.displayName || "..." : "";
        }
        case 'ASYNCSELECTCBFIELD': {
            return value ? usedObjects?.[value]?.title || "..." : "";
        }
        case 'DATEFIELD': {
            return value ? moment(value).format(window.Edocat.Config.dateFormat) : "";
        }
        case 'DATETIMEFIELD': {
            return value ? moment(value).format(window.Edocat.Config.dateTimeFormat) : "";
        }
        case 'CHECKBOXFIELD': {
            return value === 'true'
                ? window.Alfresco.messages.global['label.yes']
                : window.Alfresco.messages.global['label.no'];
        }
        default: {
            return value;
        }
    }
};
